import { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { RootState, store } from "Store/mainStore";
import { setLive } from "Store/general/theme";
import { loginRequest } from "Auth/authConfig";
import { salesChannelLogic } from "dot/Components/Misc/CaseDetails_System";
import CONFIG_API from "Constants/services/configurator";
import DOT_CONFIG_API from "dot/Constants/services/configurator";
import DATAMART_API from "Constants/services/datamart";
import DOT_DATAMART_API from "dot/Constants/services/datamart";
import OOT from "Constants/services/oot";
import DOT_OOT from "dot/Constants/services/oot";
import { callMsGraph } from "Auth/graph";
import { changeAppState, setDatamartUserRole, setError, setUser, showLoader, showAuthLoader, setUserAuthorization } from "Store/auth";

const CryptoJS = require("crypto-js");

export const setDataByKey = (state: { data: {} }, action: {
  payload: { key: string, value: string | number };
  type: string;
}) => {
  state.data = {
    ...state.data,
    [action.payload.key]: action.payload.value,
  };
}

export function isValidPositiveNumber(input) {
  // Use regex to validate positive number format
  return /^\d+(\.\d+)?$/.test(input);
}
export const haltEvents = (event) => {
  event.stopPropagation();
  event.preventDefault();
};

export const moveElement = (arr, fromIndex, toIndex) => {
  const element = arr.splice(fromIndex, 1)[0];


  arr.splice(toIndex, 0, element);

  return arr;
};

export function encodeBase64(myString) {
  // INIT
  //const myString = '75322541'; // Utf8-encoded string

  // PROCESS
  const encodedWord = CryptoJS.enc.Utf8.parse(myString); // encodedWord Array object
  const encoded = CryptoJS.enc.Base64.stringify(encodedWord); // string: 'NzUzMjI1NDE='
  return encoded;
}

export function decodeBase64(encoded) {
  // INIT
  //const encoded = 'NzUzMjI1NDE='; // Base64 encoded string

  // PROCESS
  const encodedWord = CryptoJS.enc.Base64.parse(encoded); // encodedWord via Base64.parse()
  const decoded = CryptoJS.enc.Utf8.stringify(encodedWord); // decode encodedWord via Utf8.stringify() '75322541'
  return decoded;
}
export const useHandleLogout = (logoutType) => {
  const { instance } = useMsal();
  if (logoutType === "popup") {
    instance.logoutPopup({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/",
    });
  } else if (logoutType === "redirect") {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }
};

export const checkIfCaseType_subType_Exists = (findCaseSelector,caseType, subType) => {
  let found = findCaseSelector?.caseList?.data.find(
    (dna) => dna.code === caseType && dna.sub_types?.find(st => st.code === subType)
  );
  return found;
}

export const useRenderState = (renderType, field) => {
  const findCaseSelector = useSelector((state: RootState) => state.findCase);
  const authSelector = useSelector((state: RootState) => state.authSlice);
  const caseType = findCaseSelector.data.caseType;
  const subType = findCaseSelector.data.subType
    ? findCaseSelector.data.subType
    : "none";
  const dispatch = useDispatch();
  // var found = stateMachine.find(
  //   (dna) => dna.caseType === caseType && dna.subType === subType
  // );
  const found = checkIfCaseType_subType_Exists(findCaseSelector,caseType, subType);

  let display = true; // now all the response data will be by default true 
  if (found) {
    if (authSelector?.system.currentState?.caseType !== found.caseType) { //tofix -avoid userRenderstate-multiple-rerender
      dispatch(changeAppState(found));
    }
    // switch (renderType) {
    //   case "form":
    //     // if (found.allowedComp.form.includes(field)) {
    //     //   display = true; // this is not required at the mome
    //     // }

    //     return true;

    //   case "slice":
    //     // if (found.allowedComp.slice.includes(field)) {
    //     //   display = true;
    //     // }
    //     return true;

    //   default:
    //     return display;
    // }

    //caseDetails
  }
  return display;
};

export const useAuthState = () => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();
  const authSelector = useSelector((state: RootState) => state.authSlice);

  useEffect(() => {
    // Show loader for user authentication
    dispatch(showAuthLoader(true));
    if (isAuthenticated) {
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          const adToken = response;
          const accessToken = response.accessToken;
          return callMsGraph(response.accessToken)
            .then((response) => {
              response["accessToken"] = accessToken;
              response["adToken"] = JSON.stringify(adToken);
              dispatch(setUser(response));
              OOT.init({
                accessToken: accessToken,
                email: response.mail,
                idtoken: response.adToken.idToken,
                userID: response.id,
                redX: {
                  dispatch: dispatch,
                }
              });
              DOT_OOT.init({
                accessToken: accessToken,
                email: response.mail,
                idtoken: response.adToken.idToken,
                userID: response.id,
                redX: {
                  dispatch: dispatch,
                }
              });

              // init config
              CONFIG_API.init({
                accessToken: accessToken,
                email: response.mail,
                idtoken: response.adToken.idToken,
                redX: {
                  dispatch: dispatch,
                }
              });

              // init config
              DOT_CONFIG_API.init({
                accessToken: accessToken,
                email: response.mail,
                idtoken: response.adToken.idToken,
                userID: response.id,
                redX: {
                  dispatch: dispatch,
                }
              });

              // Initialize datamart config
              DATAMART_API.init({
                accessToken: accessToken,
                email: response.mail,
                idtoken: response.adToken.idToken,
                redX: {
                  dispatch: dispatch,
                }
              });

              DOT_DATAMART_API.init({
                accessToken: accessToken,
                email: response.mail,
                idtoken: response.adToken.idToken,
                redX: {
                  dispatch: dispatch,
                },
                userId: response.id
              });
              // Get user access role from datamart
              // Call the API if any of the required user data is missing or incomplete
              // Use store.getState() to get current state instead of captured authSelector
              const currentAuthState = authSelector || store.getState().authSlice;
              
              if (!response?.mail ||
                !response?.id ||
                _.isEmpty(currentAuthState?.userDatamart_role) ||
                currentAuthState?.system?.isAuthorized === undefined) {
                // Call datamart api for user role
                getUserAccessRole(dispatch);
              }
            })
            .catch((error) => { });
        })
        .catch((e) => {
          dispatch(
            setError({
              key: "error",
              value: {
                errorCode: null,
                errorMsg: "Session Expired, re-Login to continue",
              },
            })
          );
          dispatch(setLive(false));
          setTimeout((e) => {
            instance.logoutRedirect({
              postLogoutRedirectUri: "/",
            });
          }, 3000);
        });
    } else {
      //alert("Not logged in");
    }
    return () => {
    };

  }, []);
};

export const useValidate = () => {
  const findCaseSelector = useSelector((state: RootState) => state.findCase);
  const authSelector = useSelector((state: RootState) => state.authSlice);
  const caseDetailsSelector = useSelector((state: RootState) => state.caseDetails);
  const caseType = findCaseSelector.data.caseType;
  const subType = findCaseSelector.data.subType;
  const found = checkIfCaseType_subType_Exists(findCaseSelector, caseType, subType || "none");
  let failedChecks = [];
  
  if (found) {
    const currentState = (true) ? authSelector.system.currentState : found; //tofix-make it to current state only
    
    // Build globalRequired: combination of base required fields and sales channel required fields
    const globalRequired = new Set<string>();
    
    // Add base required fields from state machine
    Object.entries(currentState.fieldsRequired).forEach((entry) => {
      const fieldName = entry[0];
      const isRequired = entry[1];
      if (isRequired) {
        globalRequired.add(fieldName);
      }
    });

    // Add sales channel specific required fields
    const selectedSalesChannel = caseDetailsSelector.data.sales_channel;
    const salesChannelRequired = salesChannelLogic[selectedSalesChannel]?.required || [];
    salesChannelRequired.forEach((fieldName) => {
      globalRequired.add(fieldName);
    });
    
    // Validate all fields in globalRequired
    globalRequired.forEach((fieldName) => {
      const value = caseDetailsSelector.data[fieldName] || findCaseSelector.data[fieldName];
      if (!value || value === '' || value === null) {
        failedChecks.push(fieldName);
      }
    });
  }
  return failedChecks;
};

export const handleGetKeyFromObj = (
  array,
  ref,
  refKey = "id",
  refValue = "value"
) => {
  try {
    if (array.length > 0 && ref) {
      var val = array.find((z) => z[refKey] === ref)[refValue];

      return val;
    }
    return "None";
  } catch (error) {
    return "None";
  }
};

export const handleGetValueFromArray = (array, ref) => {
  if (array.length > 0 && ref) {
    var val = array.find((z) => z[0] === ref)[1];
    return val;
  }
  return "None";
};

/**
 * Fetches the user's access role from the Datamart API and updates the application state.
 * 
 * @param {Function} dispatch - The dispatch function to trigger actions.
 */
const getUserAccessRole = async (dispatch) => {
  // Make the API call to get the user role
  DOT_DATAMART_API.getUserAccessRole().then((response) => {
    // Authentication is successful, hide the loader
    dispatch(showAuthLoader(false));
    if (response === undefined) {
      // Set the user authorization flag to false
      dispatch(setUserAuthorization(false));
    }
    else {
      setDatamartUserDetails(response, dispatch);
    }
  }).catch((error) => {
    // Set the user authorization flag to false
    dispatch(setUserAuthorization(false));
  });
}

export const setDatamartUserDetails = async (response, dispatch) => {
  // Set the user authorization flag to true
  dispatch(setUserAuthorization(true));
  // Check if the user is an approver
  const isUserApprover = response?.['role']?.approver || response?.["role"]?.roles.includes("approver");
  // Based on the response, set the user role and isApprover flag
  dispatch(setDatamartUserRole({ datamartRole: response?.["role"]?.roles, isApprover: isUserApprover }));
}